import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import Vuei18n from 'vue-i18n'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap'
import 'font-awesome/css/font-awesome.css'
import 'element-ui/lib/theme-chalk/index.css'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import enLocale from 'element-ui/lib/locale/lang/en'
import jaLocale from 'element-ui/lib/locale/lang/ja'

Vue.use(Vuei18n)
const i18n = new Vuei18n({
  locale: localStorage.getItem('locale') || navigator.language || 'en',
  messages: {
    en: Object.assign(require('./assets/lang/en.js'), enLocale),
    zh: Object.assign(require('./assets/lang/zh.js'), zhLocale),
    ja: Object.assign(require('./assets/lang/ja.js'), jaLocale)
  }
});

Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
});

// 原生localStorage.setItem方法
const orignalSetItem = window.localStorage.setItem;
localStorage.setItem = function (key, newValue) {
  // 重写注册setItem
  const setItemEvent = new Event("setItemEvent");
  setItemEvent.key = key;
  setItemEvent.newValue = newValue;
  // 派发setItem
  window.dispatchEvent(setItemEvent);
  // 设置值
  orignalSetItem.apply(this, arguments);
}

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
